import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'app-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ToggleComponent),
        multi: true
    }]
})
export class ToggleComponent implements OnInit, ControlValueAccessor {
    @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() disabled = false;
    @Input() size: 's' | 'm' | 'l';
    @Input() active = false;

    constructor() {
    }

    ngOnInit() {}

    toggle() {
        this.active = !this.active;
        this.onChange(this.active);
        this.changed.emit(this.active);
    }

    onChange: any = () => {};
    onTouch: any = () => {};

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }

    writeValue(value: boolean) {
        this.active = value;
    }

}
